import { gql, useMutation } from '@apollo/client';

import { GET_USER_OPEN_AI_PROCESSES } from '../queries/getOpenAiProcess.web.graphql';
import {
  GenerateSlideshowIA,
  GenerateSlideshowIAVariables,
} from '../../__generated__/queries-web';

const GENERATE_SLIDESHOW_IA = gql`
  mutation GenerateSlideshowIA(
    $slideshowLength: Int!
    $slideshowSubject: String!
    $recipeDifficulty: [RecipeDifficulty!]
    $recipeCost: [RecipeCost!]
    $brandKey: BrandKey!
  ) {
    generateSlideshowIA(
      brandKey: $brandKey
      slideshowLength: $slideshowLength
      slideshowSubject: $slideshowSubject
      recipeDifficulty: $recipeDifficulty
      recipeCost: $recipeCost
    ) {
      processId
    }
  }
`;

export const useGenerateSlideshowIA = () =>
  useMutation<GenerateSlideshowIA, GenerateSlideshowIAVariables>(
    GENERATE_SLIDESHOW_IA,
    {
      refetchQueries: [GET_USER_OPEN_AI_PROCESSES],
    },
  );
